import { Select } from '@creditornot/cb-select';
import React, { useMemo } from 'react';
import { Field, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import { useOfferingMenuFeaturesContext } from 'modules/shared-menu/contexts/OfferingMenuFeaturesContext';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { useDeposits } from '../../../hooks/useDeposits';
import { FormRowRenderer } from '../FormRowRenderer';
import { StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { AdvancedDetails, FormValues } from '../types';

export const DepositOption = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const menuFeatures = useOfferingMenuFeaturesContext();
  const intl = useIntl();
  const { data: depositOptions } = useDeposits({ enabled: menuFeatures.bottleDeposits });

  const { values } = useFormState<FormValues>();

  const depositDisplayName = useMemo(
    () => depositOptions?.find(depOpt => depOpt.value === offer?.deposit_permutation_id)?.label ?? '-',
    [depositOptions, offer?.deposit_permutation_id],
  );

  const previewComponent = depositDisplayName;

  const editComponent = (
    <Field<AdvancedDetails['depositOption']> name="depositOption">
      {field => (
        <StyledInputContainer>
          <Select {...field.input} options={depositOptions} clearable={false} />
        </StyledInputContainer>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.deposit' })}
      info={intl.formatMessage({ id: 'menu-item.deposit-tooltip' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.depositOption}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
